window.addEventListener('DOMContentLoaded', () => {

    let form = document.getElementById('blog-filter');
    
    if (form) {
        form.querySelectorAll('input[type="radio"]').forEach( radio => radio.addEventListener('change', () => form.submit() ) );
    }
    
})